<template>
    <div class="price-specification">
        <PriceSpecificationTicket
            v-for="(ticket, ticketIndex) in product.Tickets"
            :ticket="ticket"
            :index="ticketIndex"
            :key="ticketIndex" />

        <PriceSpecificationRow
            v-if="product.Tickets.length > 1"
            :price="totalPrice"
            :description="t({ key: 'shared.total_price' })"
            class="total" />
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { ActivityProduct } from '@/api/Cart/cart.interfaces';
    import { mapActivityPrice } from '../../PriceBreakdown/map/activity';
    import PriceSpecificationRow from '../PriceSpecificationRow.vue';
    import PriceSpecificationTicket from './PriceSpecificationTicket.vue';
    import { t } from '@shared/helpers/translation';

    export default defineComponent({
        name: 'PriceSpecificationActivity',
        methods: { t },
        components: { PriceSpecificationRow, PriceSpecificationTicket },
        props: {
            product: {
                type: Object as PropType<ActivityProduct>,
                required: true,
            },
        },
        setup({ product }) {
            const totalPrice = computed(() => mapActivityPrice(product));
            return {
                totalPrice,
            };
        },
    });
</script>

<style lang="scss">
    @forward '@/components/shared/PriceSpecification/PriceSpecification';
</style>
